import React, { useState } from 'react'
import { CategorySearchFilters, CategorySearchFormProps } from '../Types/category.types'
import SearchFormWrapper, { FieldConfig, SearchFormTypes } from '../../Shared/Components/SearchFormWrapper'

const CategorySearchForm = ({ onSearch }: CategorySearchFormProps) => {
    const [filters, setFilters] = useState({
        name: '',
        published: ''
    })

    const fields: FieldConfig[] = [
        { name: "name", label: "Nazwa kategorii", type: SearchFormTypes.input },
        {
            name: "published",
            label: "Opublikowany",
            type: SearchFormTypes.select,
            options: [
                { id: "true", name: "Tak" },
                { id: "false", name: "Nie" },
            ],
        },
    ];

    const handleSearch = (values: Record<string, string>) => {
        setFilters(values as unknown as CategorySearchFilters)
        onSearch({
            name: values.name,
            published: values.published
        });
    }
    return (
        <SearchFormWrapper
            fields={fields}
            initialValues={filters as unknown as Record<string, string>}
            onSubmit={handleSearch}
        />
    )
}

export default CategorySearchForm